import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: 'Inicio' },
  { path: '/nosotros', label: 'Nosotros' },
  { path: '/servicios', label: 'Servicios' },
  { path: '/contacto', label: 'Contacto' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 8);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`sticky top-0 left-0 right-0 z-50 bg-background-50 transition-all duration-300 ${
        scrolled ? 'shadow-[0_6px_24px_-12px_rgba(0,0,0,0.25)] border-b border-background-200' : 'border-b border-background-200/60'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-[4.5rem]">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 flex-shrink-0 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/5774bb29582c40f5252e7d37d3c89ae3/8954a27987ec9b2c6f4d9397aaa9290f.png"
              alt="Clínica Tarija Vitalmedic SRL"
              className="h-10 w-auto md:h-11"
            />
            <div className="flex flex-col">
              <span className="font-heading text-lg md:text-xl font-bold leading-tight text-foreground-950">
                Vital<span className="text-primary-500">medic</span>
              </span>
              <span className="text-[10px] md:text-[11px] leading-tight text-foreground-500 tracking-wide">
                Clínica Tarija SRL
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 text-sm font-medium whitespace-nowrap rounded-lg transition-colors cursor-pointer ${
                  isActive(link.path)
                    ? 'text-primary-600'
                    : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-5 h-[3px] rounded-full bg-accent-500" />
                )}
              </Link>
            ))}
            <Link
              to="/contacto"
              className="ml-3 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-check-line" />
              </span>
              Solicitar Turno
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-900 cursor-pointer"
            aria-label="Menú"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium cursor-pointer ${
                  isActive(link.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contacto"
              className="block mt-3 px-4 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold text-center cursor-pointer"
            >
              Solicitar Turno
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}